import React, { ChangeEvent } from "react";
import { Button, Col, Input, Row, Select } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import {
  LolEntityCreation,
  ViewCreation,
  WowEntityCreation,
} from "../../../types/views";

export interface EditViewModalProps {
  view: ViewCreation;
  onEntityChange: (index: number, entity: any) => void;
  onGameChange: (game: string) => void;
  onViewNameChange: (name: string) => void;
  onAddEntity: () => void;
  onDeleteEntity: (index: number) => void;
}

const CreateView = (props: EditViewModalProps) => {
  const handleWowEntityChange = (
    field: keyof WowEntityCreation,
    value: ChangeEvent<HTMLInputElement>,
    index: number,
    entity: WowEntityCreation
  ) => {
    const updatedEntity = { ...entity, [field]: value.target.value };
    props.onEntityChange(index, updatedEntity);
  };

  const handleLolEntityChange = (
    field: keyof LolEntityCreation,
    value: ChangeEvent<HTMLInputElement>,
    index: number,
    entity: LolEntityCreation
  ) => {
    const updatedEntity = { ...entity, [field]: value.target.value };
    props.onEntityChange(index, updatedEntity);
  };

  const handleOnChangeSelect = (value: string) => {
    props.onGameChange(value);
  };

  const handleOnChangeViewName = (value: ChangeEvent<HTMLInputElement>) => {
    props.onViewNameChange(value.target.value);
  };

  const getGameComponent = (game: string) => {
    switch (game) {
      case "WOW":
        return WowCreateView;
      case "LOL":
        return LolCreateView;
      case "WOW_HC":
        return WowCreateView;
      default:
        return null;
    }
  };

  const WowCreateView = (
    <div>
      <Row style={{ marginTop: "5px" }}>
        <Col span={8}>Character</Col>
        <Col span={8}>Region</Col>
        <Col span={8}>Realm</Col>
      </Row>
      <hr />
      {props.view.entities.map((entity, i) => {
        const wowEntity = entity as WowEntityCreation;
        return (
          <Row key={i}>
            <Col span={7}>
              <Input
                value={wowEntity.name}
                onChange={(value: ChangeEvent<HTMLInputElement>) =>
                  handleWowEntityChange("name", value, i, wowEntity)
                }
              />
            </Col>
            <Col span={7}>
              <Input
                style={{ marginLeft: "3px" }}
                value={wowEntity.region}
                onChange={(value: ChangeEvent<HTMLInputElement>) =>
                  handleWowEntityChange("region", value, i, wowEntity)
                }
              />
            </Col>
            <Col span={7}>
              <Input
                style={{ marginLeft: "6px" }}
                value={wowEntity.realm}
                onChange={(value: ChangeEvent<HTMLInputElement>) =>
                  handleWowEntityChange("realm", value, i, wowEntity)
                }
              />
            </Col>
            <Col span={1} />
            <Col span={2}>
              <Button
                danger
                icon={<DeleteOutlined />}
                onClick={() => props.onDeleteEntity(i)}
              />
            </Col>
          </Row>
        );
      })}
    </div>
  );

  const LolCreateView = (
    <div>
      <Row style={{ marginTop: "5px" }}>
        <Col span={12}>Name</Col>
        <Col span={12}>Tag</Col>
      </Row>
      <hr />
      {props.view.entities.map((entity, i) => {
        const lolEntity = entity as LolEntityCreation;
        return (
          <Row key={i}>
            <Col span={11}>
              <Input
                value={lolEntity.name}
                onChange={(value: ChangeEvent<HTMLInputElement>) =>
                  handleLolEntityChange("name", value, i, lolEntity)
                }
              />
            </Col>
            <Col span={10}>
              <Input
                style={{ marginLeft: "3px" }}
                value={lolEntity.tag}
                onChange={(value: ChangeEvent<HTMLInputElement>) =>
                  handleLolEntityChange("tag", value, i, lolEntity)
                }
              />
            </Col>
            <Col span={1} />
            <Col span={2}>
              <Button
                danger
                icon={<DeleteOutlined />}
                onClick={() => props.onDeleteEntity(i)}
              />
            </Col>
          </Row>
        );
      })}
    </div>
  );

  return (
    <div>
      <Row>
        <Col span={12}>Name</Col>
        <Col span={12}>
          <Input
            value={props.view.name}
            onChange={(value: ChangeEvent<HTMLInputElement>) =>
              handleOnChangeViewName(value)
            }
          />
        </Col>
      </Row>
      <Row style={{ marginTop: "5px" }}>
        <Col span={12}>Game</Col>
        <Col span={12}>
          <Select
            options={[
              { value: "WOW", label: "World of Warcraft" },
              { value: "LOL", label: "League of Legends" },
              { value: "WOW_HC", label: "WoW Classic Hardcore" },
            ]}
            value={props.view.game}
            style={{ width: "100%" }}
            onSelect={(value: string) => handleOnChangeSelect(value)}
          />
        </Col>
      </Row>
      {getGameComponent(props.view.game)}
      <Row>
        <Button style={{ marginTop: "5px" }} onClick={props.onAddEntity}>
          Add character
        </Button>
      </Row>
    </div>
  );
};

export default CreateView;
